// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260405/js/" + chunkId + "." + {"44":"2f24d809","225":"9a23ff33","481":"eb3d37a9","486":"4faea141","770":"b7dfe012"}[chunkId] + ".0.4086976926401299.chunk.js";
};